document.addEventListener('DOMContentLoaded', () => {

    const sticky = document.querySelector('#StickyAddToCart');

    const form = document.querySelector('product-form');

    if (!sticky || !form) return;

    const addButton = form.querySelector('[name="add"]');

    const stickyButton = document.querySelector('#StickyATCButton');

    stickyButton.addEventListener('click', () => {

        addButton.click();

    });

    const observer = new IntersectionObserver((entries)=>{

        entries.forEach(entry=>{

            if(entry.isIntersecting){

                sticky.classList.remove('show');

            }

            else{

                sticky.classList.add('show');

            }

        });

    },{

        threshold:.15

    });

    observer.observe(form);

});